/**
 * DREAMMANE CUSTOM — Variant Picker Morph (Anti-Flacker)
 * --------------------------------------------------------------------
 * Problem: Bei jedem Variantenwechsel ersetzt das Theme (ProductRerender
 * in theme.js) den kompletten variant-picker Block per replaceWith().
 * Folge bei 98 Varianten: Flackern, Scroll-Sprung im Farb-Slider,
 * Filter-Tabs resetten, Swatch-Bilder dekodieren neu.
 *
 * Lösung: Wir hören product:rerender in der Capture-Phase auf document
 * (läuft VOR dem ProductRerender-Handler, der direkt am Form hängt).
 * Statt den Block austauschen zu lassen, patchen wir nur das Nötige
 * in-place (checked-States, Verfügbarkeits-Klassen, gewählter Wert)
 * und entfernen den variant-picker Block aus dem Server-Fragment,
 * sodass ProductRerender ihn überspringt (matchingBlock == null).
 *
 * Gilt NUR für Container mit allow-partial-rerender (Haupt-Produktinfo).
 * Sticky-Bar und Quick-Buy-Modal (Komplett-Replace) bleiben unberührt.
 * Bei productChange (Combined Products) greifen wir nicht ein.
 */
(function () {
  'use strict';

  // Sucht ein Element per ID, auch innerhalb von <template>-Inhalten
  // (Theme nutzt teils Shadow-DOM-Templates im Server-HTML).
  function findById(root, id) {
    if (!root || !id) return null;
    var el = root.getElementById
      ? root.getElementById(id)
      : root.querySelector('#' + CSS.escape(id));
    if (el) return el;
    var templates = root.querySelectorAll ? root.querySelectorAll('template') : [];
    for (var i = 0; i < templates.length; i++) {
      el = findById(templates[i].content, id);
      if (el) return el;
    }
    return null;
  }

  function syncInputs(liveBlock, fragBlock) {
    var fragInputs = fragBlock.querySelectorAll('input[data-option-position]');
    fragInputs.forEach(function (fragInput) {
      if (!fragInput.id) return;
      var liveInput = liveBlock.querySelector('#' + CSS.escape(fragInput.id));
      if (!liveInput) return;

      liveInput.checked = fragInput.checked;
      liveInput.disabled = fragInput.disabled;

      // Verfügbarkeits-/Auswahl-Klassen am zugehörigen Label übernehmen,
      // aber unsere Filter-Klasse erhalten (kommt nicht vom Server).
      var fragLabel = fragBlock.querySelector('label[for="' + CSS.escape(fragInput.id) + '"]');
      var liveLabel = liveBlock.querySelector('label[for="' + CSS.escape(fragInput.id) + '"]');
      if (fragLabel && liveLabel) {
        var wasFiltered = liveLabel.classList.contains('is-filtered-out');
        liveLabel.className = fragLabel.className;
        if (wasFiltered) liveLabel.classList.add('is-filtered-out');
      }
    });
  }

  function syncSelectedValueTexts(liveBlock, fragBlock) {
    // "Option: Wert" Text (Block-/Swatch-Styles) — Reihenfolge der
    // Fieldsets ist zwischen Live und Fragment identisch.
    var liveInfos = liveBlock.querySelectorAll('.variant-picker__option-info .h-stack > span');
    var fragInfos = fragBlock.querySelectorAll('.variant-picker__option-info .h-stack > span');
    if (liveInfos.length === fragInfos.length) {
      for (var i = 0; i < liveInfos.length; i++) {
        if (liveInfos[i].textContent !== fragInfos[i].textContent) {
          liveInfos[i].textContent = fragInfos[i].textContent;
        }
      }
    }

    // Dropdown-Buttons (falls vorhanden): Text per stabiler ID
    fragBlock.querySelectorAll('[id$="-selected-value"]').forEach(function (fragSpan) {
      var liveSpan = liveBlock.querySelector('#' + CSS.escape(fragSpan.id));
      if (liveSpan && liveSpan.textContent !== fragSpan.textContent) {
        liveSpan.textContent = fragSpan.textContent;
      }
    });
  }

  function syncVariantJson(liveBlock, fragBlock) {
    var liveScript = liveBlock.querySelector('script[data-variant]');
    var fragScript = fragBlock.querySelector('script[data-variant]');
    if (liveScript && fragScript) {
      liveScript.textContent = fragScript.textContent;
    }
  }

  document.addEventListener('product:rerender', function (event) {
    var detail = event.detail;
    if (!detail || detail.productChange || !detail.htmlFragment) return;

    document.querySelectorAll('product-rerender[allow-partial-rerender]').forEach(function (container) {
      if (!container.id) return;

      // Nur Container morphen, deren beobachtetes Form das Event ausgelöst
      // hat. Sonst patcht ein Quick-Buy-Rerender (Fragment = komplette
      // Produktseite, gefetcht ohne section_id) den Haupt-Picker auf den
      // Quick-Buy-Stand, ohne dass dessen ProductRerender mitläuft →
      // UI und form.id laufen auseinander → falsche Variante im Warenkorb.
      var observedForm = document.forms[container.getAttribute('observe-form')];
      if (!observedForm || observedForm !== event.target) return;

      var fragContainer = findById(detail.htmlFragment, container.id);
      if (!fragContainer) return;

      container.querySelectorAll('[data-block-type="variant-picker"][data-block-id]').forEach(function (liveBlock) {
        var blockId = liveBlock.getAttribute('data-block-id');
        var fragBlock = fragContainer.querySelector(
          '[data-block-type="variant-picker"][data-block-id="' + CSS.escape(blockId) + '"]'
        );
        if (!fragBlock) return;

        // Sicherheitsnetz: Wenn die Struktur unerwartet abweicht
        // (anderes Markup nach Theme-Update), lieber den normalen
        // Replace zulassen statt halbe Syncs zu machen.
        var livePicker = liveBlock.querySelector('variant-picker');
        var fragPicker = fragBlock.querySelector('variant-picker');
        if (!livePicker || !fragPicker) return;

        syncVariantJson(liveBlock, fragBlock);
        syncInputs(liveBlock, fragBlock);
        syncSelectedValueTexts(liveBlock, fragBlock);

        // Block aus dem Fragment entfernen → ProductRerender findet
        // keinen matchingBlock und lässt den Live-Block in Ruhe.
        fragBlock.remove();
      });
    });
  }, true);
})();
